export default "__VITE_ASSET__Bw8$_qfw__"